module.exports = __webpack_public_path__ + "static/media/times-new-roman-grassetto.c5e7b45e.ttf";